import { render, staticRenderFns } from "./BankCardBlock.vue?vue&type=template&id=5ad964f7"
import script from "./BankCardBlock.vue?vue&type=script&lang=js"
export * from "./BankCardBlock.vue?vue&type=script&lang=js"
import style0 from "./BankCardBlock.vue?vue&type=style&index=0&id=5ad964f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports